import { useMemo } from 'react';
import { useGetUserMerchants } from '@/generated/hooks';
import { transformMerchants } from '@/utils/api-transformers';

export function useCurrentMerchant() {
	const merchantsQuery = useGetUserMerchants();
	const merchants = useMemo(() => transformMerchants(merchantsQuery.data), [merchantsQuery.data]);

	// MVP mode: single merchant per account; always use the first active membership.
	const selectedMerchant = merchants.length > 0 ? merchants[0] : null;
	const selectedMerchantId = selectedMerchant?.merchantId ?? null;

	return {
		selectedMerchant,
		selectedMerchantId,
		merchants,
		loading: merchantsQuery.isLoading,
		error: merchantsQuery.error?.message ?? null,
	};
}
